import { ConnectButton } from '@rainbow-me/rainbowkit'
import React from 'react'
import Logo from '../../assets/svg/logo.svg';
import { IoClose, IoMenu } from 'react-icons/io5';
import './Navbar.css'

const Navbar = () => {
    return (
        <header className='header'>
            <nav className="navbar">
                <div className="logo">
                    <img src={Logo} className="logo" alt="logo" style={{ width: '100px' }} />
                </div>

                <ConnectButton accountStatus={{ smallScreen: "small", largeScreen: "full" }} />


                {/* <aside className='menu-options'>
                    <label className="hamberger-menu" htmlFor='hamberger-checkbox'>
                        <input type="checkbox" aria-label="hamberger-menu" id='hamberger-checkbox' />
                        <IoMenu className='hamberger-btn' />
                        <IoClose className='close-btn' />
                    </label>
                    <ul className="menu-list">
                        <li className="menu-item">
                            <a href="#">How it works</a>
                        </li>
                        <li className="menu-item">
                            <a href="#">Tokenomics</a>
                        </li>
                        <li className="menu-item">
                            <a href="#">Whitepaper</a>
                        </li>
                        <li className="menu-item">
                            <ConnectButton accountStatus={{ smallScreen: "avatar", largeScreen: "full" }} />
                        </li>
                    </ul>
                </aside> */}
            </nav>
        </header>
    )
}

export default Navbar